import { useState, useEffect } from "react";
import { Landing } from "./pages/Landing";
import { MentorForm } from "./pages/MentorForm";
import { ScholarForm } from "./pages/ScholarForm";
import { Success } from "./pages/Success";
import "./index.css";

type Page = "landing" | "mentor" | "scholar" | "success-mentor" | "success-scholar";

function getInitialPage(): Page {
  const path = window.location.pathname;
  if (path === "/mentor") return "mentor";
  if (path === "/scholar") return "scholar";
  return "landing";
}

export function App() {
  const [page, setPage] = useState<Page>(getInitialPage);

  useEffect(() => {
    // Handle browser back/forward buttons
    const handlePopState = () => {
      setPage(getInitialPage());
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigate = (newPage: Page) => {
    let path = "/";
    if (newPage === "mentor") path = "/mentor";
    if (newPage === "scholar") path = "/scholar";

    window.history.pushState({}, "", path);
    setPage(newPage);
  };

  const goHome = () => navigate("landing");

  switch (page) {
    case "mentor":
      return (
        <MentorForm
          onBack={goHome}
          onSuccess={() => setPage("success-mentor")}
        />
      );
    case "scholar":
      return (
        <ScholarForm
          onBack={goHome}
          onSuccess={() => setPage("success-scholar")}
        />
      );
    case "success-mentor":
      return <Success type="mentor" onHome={goHome} />;
    case "success-scholar":
      return <Success type="scholar" onHome={goHome} />;
    default:
      return (
        <Landing
          onSelectMentor={() => navigate("mentor")}
          onSelectScholar={() => navigate("scholar")}
        />
      );
  }
}

export default App;
